var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.09,225.65c0-25.46,5.277-49.897,15.369-72.591C39.291,172.32,0,220.374,0,276.675 c0,52.253,28.789,97.387,85.449,119.056c2.971,1.127,4.508,4.355,3.432,7.325c-4.303,12.296-9.836,24.079-13.781,32.019 c-2.1,4.201,1.486,9.067,6.098,8.3c32.684-5.686,62.908-20.287,85.553-33.35c0.82-0.462,1.69-0.716,2.562-0.716 c16.137-0.564,34.832-3.512,48.973-6.533C137.785,374.275,85.09,305.262,85.09,225.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.68,363.812c62.789-26.58,96.32-78.466,96.32-138.166c0-86.764-80.736-157.102-192.965-157.102 s-192.963,70.338-192.963,157.102c0,84.524,76.066,153.418,184.318,156.923c0.873,0.028,1.705,0.304,2.406,0.823 c27.473,20.371,61.311,46.547,108.11,57.536c5.414,1.272,9.687-4.796,7.211-9.774c-3.994-8.033-14.348-32.682-20.463-48.738 C404.856,375.071,408.443,366.877,415.68,363.812z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.ace30c88.svg";
export { ForwardRef as ReactComponent };